
import api from "@/api/index"; //ABP API接口
import { Vue, Component } from "vue-property-decorator";
import { MessageBox } from "element-ui";
import {ProjectPaymentsAndReceiptsesDto, ProjectPaymentsAndReceiptsesDtoPagedResultDto} from "@/api/appService";
import EditProject from "./components/edit-PaymentsAndReceiptses.vue";
import PagedTableView from "@/components/PagedTableView/index.vue";
import ExportButton from "@/components/ExportButton/index.vue";

interface IProjectPaymentsAndReceiptsesQueryForm  {
  projectId?:number;
  projectName?:string;
  paymentCycleType?:number;
  category?:number;
  onlyMe?:boolean;
}


@Component({
  name: "projectPaymentsAndReceiptsesList",
  components: {
    ExportButton,
    EditProject,
    PagedTableView
  },
})
export default class ProjectPaymentsAndReceiptsesList extends Vue {
  tableItems: ProjectPaymentsAndReceiptsesDto[] = [];

  private currentEditId:number  = 0;
  private projectId:number = 0;
  queryForm:IProjectPaymentsAndReceiptsesQueryForm= {
    projectId: undefined,
    projectName:'',
    paymentCycleType:undefined,
    category:undefined,
    onlyMe:false

  } ;

  private cycleTypes:any = [{
    label:'首款',value:'First'
  },{
    label:'中期款',value:'Interim'
  },{
    label:'尾款',value:'Finally'
  }];
  private categories:any = [{
    label:'收款',value:'Proceeds'
  },{
    label:'拨款',value:'AllocateFunds'
  }];



  created(){
    if(this.$route.params.id){
      this.projectId = parseInt(this.$route.params.id);
    } else {
      this.projectId = 0;
    }
    this.queryForm.projectId = this.projectId;
  }



  // 获取表数据
  fetchData(param:any) {
    return api.ProjectPaymentsAndReceiptses.getAll(param);
  }

  // 新建
  handleCreate() {
    (this.$refs.editForm as any).show = true;
    this.currentEditId = 0;
  }

  // 编辑
  handleEdit(index: number, row: any) {
    this.currentEditId = row.id;
    this.projectId = row.projectId;

    (this.$refs.editForm as any).show = true;


    console.warn("%cu must reWrite this method", "color:#0048BA;");
  }

  // 删除
  async handleDelete(index: number, row: ProjectPaymentsAndReceiptsesDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.ProjectPaymentsAndReceiptses.delete({
        id: row.id
      }).then(res => {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      });
    });
  }




  // 显示详情
  jumpDetail(index: any, row: any) {
    const id = row.id;
    this.$router.push({
      name: "projectsDetail",
      params: {
        id: id
      }
    });
  }

}
